<template>
  <v-modal @cancel="$emit('cancel')">
    <v-modal-header modal-name="Purchase Offer Accept Form" @cancel="$emit('cancel')" slot="header" />
    <b-row slot="body">
      <b-col cols="12" v-if="creditorId === 'VITRINE'" class="text-center alert alert-danger">
        You have to create the "Umbuchung" in DiVA manually, because this watch is on stock in a 'Vitrine'.<br />
        <strong>No</strong> data will be send to DiVA automatically!
      </b-col>

      <b-col cols="12" v-if="!submittedSuccessfully">
        <b-row>
          <b-col cols="12" v-if="!submittedSuccessfully">
            <b-form-row>
              <b-col cols="12" md="6" class="col-form-key"> Creditor ID </b-col>
              <b-col cols="12" md="6">
                <div class="form-group">
                  <CreditorSearch
                    @creditorSelected="creditorSelected"
                    :isValid="!errors.creditorId && !!creditorId"
                    :purchaseOfferUserEmail="this.purchaseOffer.userEmail"
                  ></CreditorSearch>
                </div>
              </b-col>
            </b-form-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-row>
              <b-col cols="6" md="6" class="col-form-key"> Creditor name </b-col>
              <b-col cols="6" md="6">
                <div class="form-group">
                  <div v-if="creditorName === null">Please choose a supplier</div>
                  <div v-else>
                    {{ creditorName }}
                  </div>
                </div>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="6" md="6" class="col-form-key"> Tax liable </b-col>
              <b-col cols="6" md="6">
                <div class="form-group">
                  <div v-if="isTaxLiable === null">Please choose a supplier</div>
                  <div v-else-if="isTaxLiable === true">Yes</div>
                  <div v-else-if="isTaxLiable === false">NO</div>
                </div>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="6" md="6" class="col-form-key">Currency</b-col>
              <b-col cols="6" md="6">
                <div class="form-group">
                  <div v-if="creditorCurrency === null">Please choose a supplier</div>
                  <div v-else>
                    <span v-if="creditorCurrency !== purchaseOfferCurrency" style="color: orangered">
                      {{ creditorCurrency }}
                    </span>
                    <span v-else>
                      {{ creditorCurrency }}
                    </span>
                  </div>
                </div>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12" md="6" class="col-form-key">Price Requested</b-col>
              <b-col cols="12" md="6">
                <div class="form-group">
                  <strong v-if="purchaseOffer.price > 0">
                    {{ purchaseOffer.price / 100 }} {{ purchaseOffer.currency }}
                  </strong>
                  <em v-if="purchaseOffer.tax !== null && purchaseOffer.tax !== ''"> ({{ purchaseOffer.tax }})</em>
                  <em v-else>-</em>
                </div>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12" md="6" class="col-form-key">Price Offered</b-col>
              <b-col cols="12" md="6">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      v-model="purchaseOfferAmount"
                      min="0"
                      placeholder="Enter price like 6723,99"
                      :disabled="currentlySending"
                      :class="{
                        'is-invalid': errors.purchaseOfferAmount || !purchaseOfferAmount,
                      }"
                    />
                    <b-form-select
                      id="currency"
                      class="form-control-control-sm"
                      v-model="purchaseOfferCurrency"
                      :options="availableCurrencies"
                      :disabled="currentlySending"
                      :class="{
                        'is-invalid': purchaseOfferAmount && !purchaseOfferCurrency,
                      }"
                    >
                    </b-form-select>
                  </div>
                </div>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12" md="6" class="col-form-key"> Delivery Date </b-col>
              <b-col cols="12" md="6">
                <div class="form-group">
                  <input
                    type="text"
                    v-model="deliveryDate"
                    class="form-control"
                    id="deliveryDate"
                    :disabled="currentlySending"
                    :class="{
                      'is-invalid': errors.deliveryDate,
                    }"
                  />
                </div>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="10" md="6" class="col-form-key"> Differential Taxation ? </b-col>
              <b-col cols="2" md="6">
                <div class="form-group">
                  <input type="checkbox" v-model="diffTax" />
                </div>
              </b-col>
              <b-col
                cols="12"
                class="text-center alert alert-warning"
                v-if="!demand.diffTaxPossible && isDivaDemand(demand)"
              >
                The demand is set to
                <strong>not allow</strong> differential taxation
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="10" md="6" class="col-form-key"> Buy for which company ? </b-col>
              <b-col cols="2" md="6">
                <div class="form-group">
                  <b-form-select v-model="buyForCompany" :options="buyForCompanyOptions"></b-form-select>
                </div>
              </b-col>
            </b-form-row>
            <!--            <b-form-row>-->
            <!--              <b-col cols="10" md="6" class="col-form-key">-->
            <!--                Payment Method ?-->
            <!--              </b-col>-->
            <!--              <b-col cols="2" md="6">-->
            <!--                <div class="form-group">-->
            <!--                  <b-form-select-->
            <!--                    v-model="paymentMethod"-->
            <!--                    :options="paymentMethodOptions"-->
            <!--                  ></b-form-select>-->
            <!--                </div>-->
            <!--              </b-col>-->
            <!--            </b-form-row>-->
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="4" class="text-center">
            <b-button variant="warning" size="lg" @click="$emit('cancel')" class="btn-offer"> Close </b-button>
          </b-col>
          <b-col cols="12" md="4" class="d-sm-none d-md-flex"></b-col>
          <b-col cols="12" md="4" class="text-center">
            <div v-if="!currentlySending">
              <b-button
                variant="success"
                size="lg"
                class="btn-offer"
                @click="confirmPurchaseOffer()"
                :disabled="errors.purchaseOfferAmount || error.creditorId || !creditorId || !purchaseOfferAmount"
              >
                Confirm
              </b-button>
            </div>
            <div class="confirming-offer-div" v-if="currentlySending">Sending &nbsp; <b-spinner /></div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" v-else class="text-center">
        <div class="alert alert-success alert-offer-value-success">
          <b-iconstack scale="1.5">
            <b-icon stacked icon="circle-fill"></b-icon>
            <b-icon stacked icon="check" variant="white" scale="0.8"></b-icon>
          </b-iconstack>
          Successfully confirmed offer<br /><br />
          <b-button variant="success" @click="$emit('cancel')"> <b-icon-x /> Close </b-button>
        </div>
      </b-col>
      <b-col cols="12" v-if="error.confirmPurchaseOffer.isError === true" class="text-left mt-3">
        <div class="alert alert-danger" role="alert">
          Something went wrong. If this problem persists, please contact the IT team. Add the following details to
          better pinpoint the problem:<br />
          Code: <strong>{{ error.confirmPurchaseOffer.code }}</strong
          ><br />
          Message:
          <strong>{{ error.confirmPurchaseOffer.message }}</strong>
        </div>
      </b-col>
    </b-row>
  </v-modal>
</template>

<script>
import { getUser } from '@/auth';
import { addDays, format } from 'date-fns';
import demandMixin from 'Mixins/demand';
import { timeFormatMixin } from 'Mixins/timeFormatMixin';
import Pikaday from 'pikaday';
import apiAuth from 'src/clients/apiAuth';
import CreditorSearch from 'src/components/admin/CreditorSearch';
import constants from 'src/constants/constants';
import VModal from '../../ui/VModal';
import VModalHeader from '../../ui/VModalHeader';

const AVAILABLE_CURRENCIES = ['EUR', 'USD', 'CHF', 'SGD', 'GBP', 'HKD', 'JPY', 'NZD', 'SEK'];

export default {
  name: 'PurchaseOfferAcceptForm',
  components: {
    CreditorSearch,
    VModal,
    VModalHeader,
  },
  mixins: [timeFormatMixin, demandMixin],
  props: ['demand', 'purchaseOffer'],
  data: function () {
    return {
      currentlySending: false,
      submittedSuccessfully: false,
      purchaseOfferCurrency: null,
      purchaseOfferAmount: null,
      deliveryDate: null,
      creditorId: null,
      creditorName: null,
      creditorCurrency: null,
      diffTax: false,
      error: {
        confirmPurchaseOffer: {
          isError: false,
          code: null,
          message: '',
        },
      },
      errors: {
        purchaseOfferAmount: false,
      },
      showSearchCreditor: false,
      isTaxLiable: null,
      buyForCompany: null,
      buyForCompanyOptions: [
        { value: null, text: 'Select one option' },
        // { value: 'efg', text: 'EFG' },
        { value: 'chronext', text: 'Chronext' },
        // { value: 'bv', text: 'BV' },
      ],
      // paymentMethod: null,
      // paymentMethodOptions: [
      //   { value: null, text: 'Select one option' },
      //   { value: 1, text: 'Option 1' },
      //   { value: 2, text: 'Option 2' },
      // ],
    };
  },
  computed: {
    availableCurrencies: () => AVAILABLE_CURRENCIES,
  },
  methods: {
    resetError(errorKey) {
      this.error[errorKey].isError = false;
      this.error[errorKey].code = null;
      this.error[errorKey].message = '';
    },
    setError(errorKey, code, message) {
      this.error[errorKey].isError = true;
      this.error[errorKey].code = code;
      this.error[errorKey].message = message;
    },
    isValidPrice() {
      this.errors.purchaseOfferAmount =
        !new RegExp('^\\d*(\\.\\d{0,2})?$').test(this.purchaseOfferAmount) || this.purchaseOfferAmount < 0;

      return !this.errors.purchaseOfferAmount;
    },
    isValidDeliveryDate() {
      let endDate = new Date();
      endDate.setHours(23, 59, 59, 999);
      this.errors.deliveryDate = this.parseDate(this.deliveryDate).getTime() <= endDate.getTime();

      return !this.errors.deliveryDate;
    },
    isValidCreditorId() {
      this.errors.creditorId = this.creditorId === null || this.creditorId.length === 0;

      return !this.errors.creditorId;
    },
    isValidOffer() {
      return (
        this.isValidPrice() && this.isValidDeliveryDate() && this.isValidCreditorId() && this.buyForCompany !== null
      );
    },
    confirmPurchaseOffer() {
      if (!this.isValidOffer()) {
        return false;
      }
      let options = {
        method: 'post',
        url: constants.url.demandService.baseUrl + constants.url.demandService.api.fulfillDemand,
        data: {
          demandId: this.demand.demandId,
          purchaseOfferId: this.purchaseOffer.purchaseOfferId,
          acceptedPrice: Math.round(this.purchaseOfferAmount * 100),
          acceptedCurrency: this.purchaseOfferCurrency || this.creditorCurrency,
          deliveryDate: this.deliveryDate,
          creditorId: '' + this.creditorId,
          orderNumber: this.demand.orderNumber,
          lineNumber: this.demand.lineNumber,
          productKey: this.demand.productKey,
          variantKey: this.demand.variantKey,
          differentialTaxation: this.diffTax,
          userId: getUser().uid,
          buyForCompany: this.buyForCompany,
        },
      };
      this.currentlySending = true;
      this.resetError('confirmPurchaseOffer');
      apiAuth(options)
        .then(() => {
          this.submittedSuccessfully = true;
          this.currentlySending = false;
          this.$emit('purchase-offer-accepted');
        })
        .catch((error) => {
          this.setError(
            'confirmPurchaseOffer',
            error.response.status,
            `${error.response.data.code}; \
             ${error.response.data.title} \
             ${error.response.data.detail} \
             / Demand ID: \
             ${options.data.demandId} \
             / Purchase Offer ID: \
             ${options.data.purchaseOfferId}`,
          );
          this.currentlySending = false;
        });
    },
    creditorSelected(creditor) {
      if (creditor === null) {
        return this.creditorManual();
      }
      this.creditorId = creditor.creditorId;
      this.isTaxLiable = creditor.isTaxLiable;
      this.creditorCurrency = creditor.currencyCode;
      this.creditorName = creditor.name;
    },
    creditorManual() {
      this.isTaxLiable = null;
      this.creditorName = null;
      this.creditorId = null;
      this.creditorCurrency = null;
    },
  },
  mounted: function () {
    this.deliveryDate = format(addDays(new Date(), 1), 'yyyy-MM-dd');
    this.purchaseOfferAmount = this.purchaseOffer.price / 100;
    this.purchaseOfferCurrency = this.purchaseOffer.currency || this.creditorCurrency;

    this.$nextTick(function () {
      let self = this;
      new Pikaday({
        field: document.getElementById('deliveryDate'),
        format: 'yyyy-MM-dd',
        minDate: new Date(),
        toString(date) {
          return self.formattedDate(date);
        },
        parse(dateString) {
          return self.parseDate(dateString);
        },
        onSelect: function () {
          self.deliveryDate = this.toString();
        },
      });
    });
  },
  watch: {
    purchaseOfferAmount: {
      handler: function () {
        this.isValidOffer();
      },
      deep: true,
    },
    creditorId: {
      handler: function () {
        this.isValidOffer();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.confirming-offer-div {
  font-size: 1.3rem;
}

.col-form-key {
  text-align: right;
  @media all and (max-device-width: 576px) {
    text-align: left;
  }
}

.btn-offer {
  width: 100%;
}

.alert-offer-value-success {
  margin-bottom: 0;
}

.row-form {
  margin-bottom: 8px;
}

.usersearch {
  position: relative;
  &__resultlist {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    list-style: none;
    margin: 0;
    padding: 0;
    background: #fff;
    border: 1px solid #ccc;
    border-top: none;
    z-index: 2;
  }
  &__resultitem {
    border-bottom: 1px solid #ccc;
    &:last-child {
      border-bottom: none;
    }
    &.is-active {
      background: orange;
    }
  }
}
</style>
